import { defineStore } from 'pinia'
import { ToastType, type MassageModel } from '../types/model/toast'

export const useToastStore = defineStore('messages', {
  state: () => ({
    messages: [] as MassageModel[],
  }),

  actions: {
    setMassage(data: MassageModel) {
      this.messages.push({ ...data, isOpen: true })
    },

    showSuccessToast(message: string) {
      this.setMassage({
        message: [message],
        toastType: ToastType.Success,
        isOpen: true,
      })
    },
    clearError() {
      this.messages = []
    },
  },
})
